export default function chartProcessSocio(res, data) {
  const result = [];
  for (const key in res) {
    if (res.hasOwnProperty(key)) {
      result.push({
        name: key,
        total: res[key],
        format: res[key].toLocaleString('es-MX', { maximumFractionDigits: 0 }),
        fill: getColor(key, data),
      });
    }
  }

  return result;
}

const getColor = (name, data) => {
  const index = data.findIndex((item) => item.name === name);
  return data[index].color;
};
